import DeviceContainer from '@/components/DeviceContainer';
import { ServiceRequestContext, serviceReqHistoryInterface } from '@/context/serviceRequestContext';
import { useContext, useEffect, useState } from 'react';
import { PendingRequests } from '../../SubComponents/pendingRequests';
import { AssetsData } from '@/types/asset';
import { AppScreens, WebEngageEventNames } from '@/types/wegengage';
import { WebEngageContext } from '@/context/webengageContext';
import { ProductContext } from '@/context/productContext';
import WebEngageUtils from '@/utils/webengageUtils';
import { disableScroll, enableScroll } from '@/components/DeviceContainer/deviceSelectionModal';
import Button from '@/shared/Button';

interface BookAServiceProps {
  productData: AssetsData[];
  serviceReqHistoryData: serviceReqHistoryInterface;
  showBookServiceCta?: boolean;
}

const BookAService = (props: BookAServiceProps) => {
  const { productData, serviceReqHistoryData, showBookServiceCta = true } = props;
  const { dispatch: serviceAction } = useContext(ServiceRequestContext);
  const { state: webengageState } = useContext(WebEngageContext);
  const [isLoading, setIsLoading] = useState(false);
  const { state: productState } = useContext(ProductContext);
  const { selectedProduct } = productState;
  const _isSROpen = WebEngageUtils.returnBoolString(
    serviceReqHistoryData?.openRequests?.length > 0,
  );
  useEffect(() => {
    serviceAction.setIsRouting(false);
  }, []);

  useEffect(() => {
    if (productState.disablePageScroll) {
      disableScroll();
    } else {
      enableScroll();
    }
  }, [productState.disablePageScroll]);

  return (
    <section className="flex flex-col">
      <DeviceContainer productsData={productData} isServicePage />
      <div className="relative">
        {/* {!showBookServiceCta ? null : (
          <Button
            className="w-full md:w-max md:self-end   my-6 md:my-0 md:absolute right-0 md:top-12 grid place-content-center"
            theme="primary"
            onClick={() => {
              setIsLoading(true);
              serviceAction.resetServiceAllocation();
              serviceAction.changeComponent('bookAService');
              setIsLoading(false);
              const _we = window.webengage;
              if (_we) {
                serviceAction.initWebengageContext({
                  customer_type: WebEngageUtils.stringUtil(selectedProduct?.expiryStatus?.status),
                  service_request_open: _isSROpen,
                  scheduling_automation_flow: 'Yes',
                });
                _we.track(WebEngageEventNames.BOOK_A_SERVICE_CLICKED, {
                  ...webengageState.webengageDefault,
                  navigated_from: AppScreens.SERVICE_BOOKING_SCREEN,
                  customer_type: WebEngageUtils.stringUtil(selectedProduct?.expiryStatus?.status),
                  service_request_open: _isSROpen,
                  scheduling_automation_flow: 'Yes',
                });
              }
            }}
            disabled={isLoading}
            dataTestId="book-service"
            isLoading={isLoading}
          >
            BOOK A SERVICE
          </Button>
        )} */}
        <PendingRequests serviceReqHistory={serviceReqHistoryData} />
      </div>
    </section>
  );
};

export default BookAService;
